import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router';
import styled from 'styled-components';

import { catchAll } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  ANY_SPORT_SCOUTING_CENTER_MATCHES,
  ANY_SPORT_SCOUTING_CENTER_STATS,
  ANY_SPORT_SCOUTING_CENTER_WATCHLISTS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import {
  glossary,
  navLabels,
  scoutingCenter,
} from '@sorare/core/src/lib/glossary';

const Wrapper = styled(Vertical)`
  min-height: calc(100vh - var(--current-stack-height));
`;

enum ScoutingCenterTabs {
  STATS = 'stats',
  MATCHES = 'matches',
  WATCHLISTS = 'watchlists',
}

const ScoutingCenterLayout = () => {
  const { generateSportContextPath, generateSportContextPathPattern, sport } =
    useSportContext();

  const tabs = [
    {
      tab: ScoutingCenterTabs.STATS,
      label: navLabels.stats,
      to: {
        pathname: generateSportContextPath(ANY_SPORT_SCOUTING_CENTER_STATS),
        search: 'ps=starter,regular',
      },
      matches: [
        catchAll(
          generateSportContextPathPattern(ANY_SPORT_SCOUTING_CENTER_STATS)
        ),
      ],
    },
    {
      tab: ScoutingCenterTabs.MATCHES,
      label: sport === Sport.FOOTBALL ? glossary.matches : glossary.games,
      to: generateSportContextPath(ANY_SPORT_SCOUTING_CENTER_MATCHES),
      matches: [
        catchAll(
          generateSportContextPathPattern(ANY_SPORT_SCOUTING_CENTER_MATCHES)
        ),
      ],
    },
    {
      tab: ScoutingCenterTabs.WATCHLISTS,
      label: scoutingCenter.watchlists,
      to: generateSportContextPath(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS),
      matches: [
        catchAll(
          generateSportContextPathPattern(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS)
        ),
      ],
    },
  ];

  return (
    <ContentWithStickyHeader
      header={
        <TabBar variant="flat" fullWidth ignoreQueryParams>
          {tabs.map(({ to, tab, label, matches }) => (
            <Tab key={tab} to={to} matches={matches}>
              <FormattedMessage {...label} />
            </Tab>
          ))}
        </TabBar>
      }
    >
      <Wrapper>
        <Outlet />
      </Wrapper>
    </ContentWithStickyHeader>
  );
};

export default ScoutingCenterLayout;
